import { render, staticRenderFns } from "./global-guide.vue?vue&type=template&id=36e669c8&scoped=true&"
import script from "./global-guide.vue?vue&type=script&lang=js&"
export * from "./global-guide.vue?vue&type=script&lang=js&"
import style0 from "./global-guide.vue?vue&type=style&index=0&id=36e669c8&lang=scss&scoped=true&"
import style1 from "./global-guide.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e669c8",
  null
  
)

export default component.exports